import React, { useState } from 'react';
import { Typography, Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import MarkdownRenderer from '../../../../helper/MarkdownRenderer/MarkdownRenderer';
import AddQuestionModal from './modals/AddQuestionModal';

export interface IMainQuestionManager {
  mode?: 'edit' | 'readOnly';
  question: string;
  updateDetails?: (markdown: string) => void;
}

const MainQuestionManager: React.FC<IMainQuestionManager> = ({
  mode = 'edit',
  question,
  updateDetails,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  return (
    <div style={{ marginBottom: '15px' }}>
      <Typography fontWeight={600}>
        {mode === 'edit' ? 'Enter main question' : 'Main Question'}
      </Typography>
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <Box sx={{ mb: 2 }}>
          <MarkdownRenderer content={question} />
        </Box>
      </div>
      {mode === 'edit' && (
        <div>
          <Button
            startIcon={<AddIcon />}
            onClick={() => setModalOpen(true)}
            sx={{ mt: '10px' }}
          >
            {question.trim() ? 'Edit' : 'Add'}
          </Button>
        </div>
      )}
      {isModalOpen && updateDetails && (
        <AddQuestionModal
          open={isModalOpen}
          question={question}
          onClose={() => setModalOpen(false)}
          updateDetails={(markdown) => {
            updateDetails(markdown);
            setModalOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default MainQuestionManager;
